import { UserData } from 'springroll';

let instance = null;

const LOCAL_STORAGE_KEY = 'pbs_hideseek';
class LocalStorage {
  constructor() {
    if (instance) {
      return instance;
    }
    instance = this;
    this.useSpringroll = false;
    this.onRead = new Phaser.Signal();
    return instance;
  }

  isSupported() {
    return typeof Storage !== 'undefined';
  }

  parseData(data) {
    try {
      return JSON.parse(data);
    } catch (e) {}
    return undefined;
  }

  handleLoadSuccess(value) {
    console.log('Value retrieved:', value);
    this.useSpringroll = true;
    this.data = this.parseData(value);
    if (this.data) {
      // if no data try to read from local storage to restore old data and then save
      const data = window.localStorage.getItem(LOCAL_STORAGE_KEY);
      if (data) {
        this.data = this.parseData(data);
        UserData.write(LOCAL_STORAGE_KEY, this.data).then(() => console.log('Value saved'));
      }
    }
    this.onRead.dispatch();
  }

  handleLoadFail(reason) {
    console.log('load error:', reason);
    // connection error to UserData, try use local storage
    const data = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    this.data = this.parseData(data) || {};
    this.onRead.dispatch();
  }

  loadData() {
    /* use below to support only local storage */
    this.handleLoadFail();

    /* use below to support UserData - it requires tests */
    // UserData.read(LOCAL_STORAGE_KEY).then(
    //   this.handleLoadSuccess.bind(this),
    //   this.handleLoadFail.bind(this)
    // );
  }

  setGameData(key, value) {
    this.data[key] = value;
    if (this.useSpringroll) {
      UserData.write(LOCAL_STORAGE_KEY, this.data).then(() => console.log('Value saved'));
    } else {
      try {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.data));
      } catch (e) {}
    }
  }

  getGameData() {
    return this.data;
  }

  destroy() {
    instance = null;
  }
}

export function getLS() {
  return new LocalStorage();
}
